'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Test(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 5 }, className: 'jsx-3383499909' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3383499909' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'svg',
      {
        width: size,
        height: size + 5,
        viewBox: '0 0 43 48',
        version: '1.1',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        className: 'jsx-3383499909'
      },
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(-5.000000, -4.000000)',
          stroke: 'none',
          strokeWidth: 1,
          fill: 'none',
          fillRule: 'evenodd',
          className: 'jsx-3383499909'
        },
        _react2.default.createElement('rect', { fill: '#49497F', x: 10, y: 12, width: 38, height: 40, rx: 6, className: 'jsx-3383499909'
        }),
        _react2.default.createElement('rect', { fill: '#F2F2F2', x: 11, y: 10, width: 36, height: 40, rx: 5, className: 'jsx-3383499909'
        }),
        _react2.default.createElement('rect', { fill: '#B7C1C4', x: 11, y: 8, width: 36, height: 40, rx: 5, className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'mask',
          { fill: '#fff', className: 'jsx-3383499909'
          },
          _react2.default.createElement('rect', { x: 10, y: 4, width: 38, height: 42, rx: 6, className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement('rect', { fill: '#7878CB', x: 10, y: 4, width: 38, height: 42, rx: 6, className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'g',
          { fill: '#FFF', className: 'jsx-3383499909'
          },
          _react2.default.createElement(
            'g',
            { transform: 'translate(22.000000, 17.000000)', className: 'jsx-3383499909'
            },
            _react2.default.createElement('path', { d: 'M7.494 16C3.424 16.06.074 12.545 0 8.137 0 6.958.884 6 1.974 6c1.09 0 1.974.957 1.974 2.138 0 2.124 1.59 3.846 3.552 3.846s3.552-1.722 3.552-3.846c0-1.18.884-2.138 1.974-2.138C14.116 6 15 6.957 15 8.138c-.073 4.408-3.424 7.922-7.494 7.861M13.003 4a2.018 2.018 0 0 1-1.418-.59A1.983 1.983 0 0 1 11 1.996a2.001 2.001 0 0 1 4 0c0 .534-.211 1.043-.585 1.412-.38.377-.885.588-1.412.591m-11 0a2.018 2.018 0 0 1-1.418-.591A1.985 1.985 0 0 1 0 1.996C0 1.463.211.953.585.584a2.006 2.006 0 0 1 2.83 0C3.789.953 4 1.463 4 1.996c0 .534-.211 1.044-.585 1.413-.38.377-.885.588-1.412.591', className: 'jsx-3383499909'
            })
          )
        ),
        _react2.default.createElement('path', {
          d: 'M9.956 12h4.04c.71 0 1.283.53 1.283 1.184 0 .655-.574 1.185-1.282 1.185H9.96c-1.257.018-2.27.965-2.27 2.131 0 1.177 1.032 2.131 2.307 2.131 0 .284.044 1.104 0 2.369-2.645-.044-4.753-2.054-4.717-4.497-.036-2.436 2.05-4.438 4.676-4.502z',
          fill: '#49497F',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M9.956 21.993l4.04-.001c.71 0 1.283.53 1.283 1.184 0 .655-.574 1.185-1.282 1.185H9.96c-1.257.018-2.27.965-2.27 2.13 0 1.178 1.032 2.132 2.307 2.132 0 .284.044 1.104 0 2.369-2.645-.044-4.753-2.054-4.717-4.497-.036-2.436 2.05-4.438 4.676-4.502z',
          fill: '#49497F',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M9.956 31.966l4.04-.001c.71 0 1.283.53 1.283 1.184 0 .654-.574 1.185-1.282 1.185H9.96c-1.257.018-2.27.965-2.27 2.13 0 1.178 1.032 2.132 2.307 2.132 0 .284.044 1.104 0 2.369-2.645-.044-4.753-2.054-4.717-4.497-.036-2.437 2.05-4.439 4.676-4.502z',
          fill: '#49497F',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M40.339 43.21h-.081a.334.334 0 0 1-.329-.154.345.345 0 0 1 0-.367.334.334 0 0 1 .329-.154h.08c.393 0 .783-.047 1.164-.139a.343.343 0 0 1 .156.63 5.681 5.681 0 0 1-1.32.159v.025zm-2.744 0h-1.332a.334.334 0 0 1-.328-.154.345.345 0 0 1 0-.367.334.334 0 0 1 .328-.154h1.332a.34.34 0 0 1 .29.338.34.34 0 0 1-.29.337zm-4 0h-1.332a.334.334 0 0 1-.329-.154.345.345 0 0 1 0-.367.334.334 0 0 1 .329-.154h1.331a.34.34 0 0 1 .29.338.34.34 0 0 1-.29.337zm10.309-1.394a.336.336 0 0 1-.305-.217.344.344 0 0 1 .08-.37c.315-.294.587-.632.81-1.002a.333.333 0 0 1 .433-.072c.142.089.199.27.133.425-.25.41-.553.783-.902 1.11a.327.327 0 0 1-.243.1l-.006.026zm1.543-3.608a.338.338 0 0 1-.336-.34v-1.375a.338.338 0 0 1 .333-.295c.168 0 .31.126.333.295v1.35a.338.338 0 0 1-.324.334l-.006.031zm0-4.055a.338.338 0 0 1-.336-.34v-1.376a.342.342 0 0 1 .152-.333.332.332 0 0 1 .362 0c.11.071.17.202.152.333v1.35a.339.339 0 0 1-.324.34l-.006.026zm0-4.056a.338.338 0 0 1-.336-.34v-1.375a.342.342 0 0 1 .152-.334.332.332 0 0 1 .362 0c.11.072.17.202.152.334v1.35a.339.339 0 0 1-.324.34l-.006.025zm0-4.056a.338.338 0 0 1-.336-.34v-1.369a.342.342 0 0 1 .152-.333.332.332 0 0 1 .362 0c.11.072.17.202.152.333v1.35a.338.338 0 0 1-.324.334l-.006.025zm0-4.055a.338.338 0 0 1-.336-.34v-1.37a.342.342 0 0 1 .152-.333.332.332 0 0 1 .362 0c.11.072.17.202.152.334v1.35a.338.338 0 0 1-.324.308l-.006.05zm0-4.056a.338.338 0 0 1-.336-.34V16.22a.338.338 0 0 1 .333-.294c.168 0 .31.125.333.294v1.35a.339.339 0 0 1-.324.34l-.006.02zm0-4.055a.338.338 0 0 1-.336-.34v-1.363a.338.338 0 0 1 .333-.295c.168 0 .31.126.333.295v1.35a.338.338 0 0 1-.324.334l-.006.019zm-.336-4.03a.336.336 0 0 1-.311-.215 4.506 4.506 0 0 0-.622-1.085.344.344 0 0 1 .075-.454.333.333 0 0 1 .453.038c.292.385.529.81.704 1.261a.339.339 0 0 1-.187.442.326.326 0 0 1-.112.019v-.007zm-2.744-2.77a.332.332 0 0 1-.124 0 4.924 4.924 0 0 0-1.201-.328.34.34 0 0 1-.242-.375.337.337 0 0 1 .335-.293c.468.066.926.19 1.363.372a.342.342 0 0 1-.125.63l-.006-.006zm-3.92-.397h-1.362a.34.34 0 0 1-.29-.337.34.34 0 0 1 .29-.338h1.331a.334.334 0 0 1 .329.154c.07.112.07.255 0 .367a.334.334 0 0 1-.329.154h.031zm-4 0h-1.363a.334.334 0 0 1-.329-.154.345.345 0 0 1 0-.367.334.334 0 0 1 .33-.154h1.33a.34.34 0 0 1 .29.338.34.34 0 0 1-.29.337h.032z',
          fill: '#49497F',
          fillRule: 'nonzero',
          opacity: '0.5',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M17.428 43.21h.08a.333.333 0 0 0 .328-.154.345.345 0 0 0 0-.367.333.333 0 0 0-.328-.154h-.08c-.391 0-.78-.047-1.161-.139a.343.343 0 0 0-.155.63c.43.105.872.158 1.316.159v.025zm2.737 0h1.328a.333.333 0 0 0 .328-.154.345.345 0 0 0 0-.367.333.333 0 0 0-.328-.154h-1.328a.339.339 0 0 0-.29.338c0 .17.124.314.29.337zm3.834 0h1.328a.333.333 0 0 0 .328-.154.345.345 0 0 0 0-.367.333.333 0 0 0-.328-.154H24a.339.339 0 0 0-.29.338c0 .17.124.314.29.337zm3.843 0h1.322a.339.339 0 0 0 .29-.337.339.339 0 0 0-.29-.338h-1.328a.333.333 0 0 0-.328.154.345.345 0 0 0 0 .367c.07.112.198.172.328.154h.006zm-13.97-1.394a.335.335 0 0 0 .304-.217.345.345 0 0 0-.081-.37 4.653 4.653 0 0 1-.807-1.002.331.331 0 0 0-.433-.072.344.344 0 0 0-.132.425c.25.41.552.783.9 1.11a.326.326 0 0 0 .242.1l.006.026zm-1.54-3.608a.338.338 0 0 0 .335-.34v-1.375a.337.337 0 0 0-.332-.295.337.337 0 0 0-.332.295v1.35c.003.18.145.327.323.334l.006.031zm0-4.055a.338.338 0 0 0 .335-.34v-1.376a.343.343 0 0 0-.151-.333.33.33 0 0 0-.361 0 .343.343 0 0 0-.152.333v1.35c0 .183.143.334.323.34l.006.026zm0-4.056a.338.338 0 0 0 .335-.34v-1.375a.343.343 0 0 0-.151-.334.33.33 0 0 0-.361 0 .343.343 0 0 0-.152.334v1.35c0 .183.143.333.323.34l.006.025zm0-4.056a.338.338 0 0 0 .335-.34v-1.369a.343.343 0 0 0-.151-.333.33.33 0 0 0-.361 0 .343.343 0 0 0-.152.333v1.35c.003.18.145.328.323.334l.006.025zm0-4.055a.338.338 0 0 0 .335-.34v-1.37a.343.343 0 0 0-.151-.333.33.33 0 0 0-.361 0 .343.343 0 0 0-.152.334v1.35a.338.338 0 0 0 .323.308l.006.05zm0-4.056a.338.338 0 0 0 .335-.34V16.22a.337.337 0 0 0-.332-.294.337.337 0 0 0-.332.294v1.35c0 .183.143.334.323.34l.006.02zm0-4.055a.338.338 0 0 0 .335-.34v-1.363a.337.337 0 0 0-.332-.295.337.337 0 0 0-.332.295v1.35c.003.18.145.327.323.334l.006.019zm.335-4.03c.137-.001.26-.086.31-.215.156-.39.365-.755.621-1.085a.344.344 0 0 0-.075-.454.331.331 0 0 0-.452.038c-.291.385-.528.81-.702 1.261a.34.34 0 0 0 .001.261.331.331 0 0 0 .185.18c.036.014.074.02.112.02v-.007zm2.737-2.77a.33.33 0 0 0 .124 0c.385-.16.787-.27 1.198-.328a.34.34 0 0 0 .242-.375.337.337 0 0 0-.335-.293c-.466.066-.923.19-1.36.372a.343.343 0 0 0 .125.63l.006-.006zm3.91-.397h1.36a.339.339 0 0 0 .29-.337.339.339 0 0 0-.29-.338h-1.329a.333.333 0 0 0-.327.154.345.345 0 0 0 0 .367c.07.112.198.172.327.154h-.03zm4.158 0h1.36a.333.333 0 0 0 .327-.154.345.345 0 0 0 0-.367.333.333 0 0 0-.328-.154h-1.328a.339.339 0 0 0-.29.338c0 .17.124.314.29.337h-.03zm4.293 0h1.353a.333.333 0 0 0 .327-.154.345.345 0 0 0 0-.367.333.333 0 0 0-.327-.154h-1.329a.339.339 0 0 0-.29.338c0 .17.124.314.29.337h-.024z',
          fill: '#49497F',
          fillRule: 'nonzero',
          opacity: '0.5',
          className: 'jsx-3383499909'
        })
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '3383499909'
      },
      ['.green.jsx-3383499909{fill:#00b083;}', '.purple.jsx-3383499909{fill:#7878cb;}', '.gray.jsx-3383499909{fill:#767c7c;}', '.holder.jsx-3383499909{position:relative;display:inline-block;}', '.icon.jsx-3383499909{position:absolute;bottom:-10%;right:-5%;z-index:2;}']
    )
  );
}

Test.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = Test;